<div class="ai-button-container">
  <button
    class="ai-button"
    type="button"
    (click)="onClick()"
    [disabled]="!isButtonEnabled"
    [ngClass]="{
      disabled: !isButtonEnabled,
      generating: isLoading,
      small: isSmall,
    }"
  >
    <div class="ai-button-content-container">
      @if (!isLoading) {
        <img
          src="../../../assets/images/icon/gen4u-generate-resource.svg"
          class="ai-button-icon"
        />
      }
      @if (isLoading) {
        <mat-spinner diameter="30"></mat-spinner>
      }
      <span>
        {{ buttonText }}
      </span>
    </div>
  </button>
</div>
